<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex>
        <v-card>
          <v-toolbar>
            <v-toolbar-title>Sign In</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              name="email"
              label="Email"
              v-model="email"
              type="email"
              hint="Please enter your email address here"
              :rules="[() => email.length > 0 || 'This field is required']"
              required>
            </v-text-field>
            <v-text-field
              name="password"
              label="Password"
              v-model="password"
              type="password"
              hint="Please enter your password here"
              :rules="[() => password.length > 0 || 'This field is required']"
              required>
            </v-text-field>
            <small>*indicates required field</small>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn @click="login" :disabled="loading" :loading="loading">
              Login
              <span slot="loader" class="custom-loader">
                <v-icon light>cached</v-icon>
              </span>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import mixins from '@/mixins.js'
import AuthenticationService from '@/services/AuthenticationService'
export default {
  data () {
    return {
      email: '',
      password: '',
      error: 'JWT Token Session Timeout (Not Idle Timeout). Please Login Again.'
    }
  },
  mixins: [mixins],
  computed: {
    loading() {
      var audio = new Audio( '/static/beep_warning.mp3')
      audio.play()
      return this.$store.getters.loading
    }
  },
  methods: {
    async login () {
      try {
        const response = await AuthenticationService.login({
          email: this.email,
          password: this.password
        })
        this.error = 'Login Successful'
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        var isNurse = false
        var roles = response.data.user.roles
        if (roles) {
          for (var i = 0; i < roles.length; i++) {
            console.log(roles[i].roleId)
            if (roles[i].roleId === 13 ) {
              isNurse = true
            }
          }
        }
        if (isNurse) {
          this.$router.push({name: 'alert'})
        } else {
          this.$router.push({name: 'homeLoggedIn'})
        }
      } catch (error) {
        this.error = this.errMsg = this.handleError(error)
      }
    }
  }
}
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginTimeout.vue